export const ROLES = {
    User: "user",
    Staff: "staff",
    Manager: "manager",
    Admin: "admin"
}